// import { useState, useEffect } from "react";
// import { Button } from "../../components/Button";
// import { newsletter } from "../../../datasets/solutions/newsletter";
// import { sendGaEvent } from "../../../../config/userTracking";
// import { userApi } from "../../../../api/userApi";

export const NewsletterSection = ({ show = false }) => {
  if (show === false) return null;

  // const { pathname } = useLocation();
  // const [email, changeEmail] = useState("");
  // const [formData, changeFormData] = useState({});
  // const [error, changeError] = useState("");

  // const validate = () => {
  //   changeError("");
  //   if (email.length === 0) {
  //     changeError(newsletter.errors.field_required);
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  // useEffect(() => {
  //   changeError("");
  //   let formData = {
  //     email,
  //   };
  //   changeFormData(formData);
  // }, [email]);

  // const handleSubmit = async e => {
  //   e.preventDefault();
  //   if (validate() === true) {
  //     sendGaEvent({
  //       action: "Form Submission",
  //       category: "Lead",
  //       label: `Submit - Newsletter - ${pathname}`,
  //     });
  //     console.log("sending...");
  //     try {
  //       await userApi.sendFrontForm(formData);
  //     } catch (e) {
  //       console.info(e);
  //     } finally {
  //       console.log("sent");
  //     }
  //   } else {
  //     console.log(formData);
  //   }
  // };

  // return (
  //   <section className="newsletter-background">
  //     <section className="section-layout">
  //       <article className="newsletter-text">
  //         <h1 className="newsletter-head">{newsletter.head}</h1>
  //         <form onSubmit={e => handleSubmit(e)}>
  //           <p className="newsletter-error">{error}</p>
  //           <input
  //             type="email"
  //             className="newsletter-input"
  //             onChange={e => changeEmail(e.target.value)}
  //             placeholder={newsletter.placeholder}
  //             value={email}
  //           />
  //           <Button variant="secondary" demystIcon>
  //             {newsletter.button}
  //             <input type="submit" value={newsletter.button} />
  //           </Button>
  //         </form>
  //       </article>
  //     </section>
  //   </section>
  // );
};
